import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import SubHeader from 'components/common/SubHeader';
import { SubHeaderOptions } from 'constants/index';
import { GetRetailAPI } from 'api/space';
import { spaceActions } from 'store/space';
import RetailDetailService from 'components/retail/_detail';
import { useRouter } from 'next/router';
import { ERROR_500 } from 'constants/message';

var RetailDetail = function RetailDetail(_ref) {
  var error = _ref.error;
  var router = useRouter();
  useEffect(function () {
    if (error) {
      alert(ERROR_500);
      router.push('/');
    }
  }, [error, router]);

  if (error) {
    return null;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SubHeader, {
      options: SubHeaderOptions,
      selected: "\uB9AC\uD14C\uC77C"
    }), /*#__PURE__*/_jsx(RetailDetailService, {})]
  });
};

RetailDetail.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var store, query, id, retail;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = _ref2.store, query = _ref2.query;
            id = query.id;
            _context.next = 4;
            return GetRetailAPI(id);

          case 4:
            retail = _context.sent;

            if (!(retail.status >= 400)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", {
              error: true
            });

          case 7:
            store.dispatch(spaceActions.getRetail(retail.data));
            return _context.abrupt("return", {
              error: false
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

export default RetailDetail;